// 托管状态的值
export const COLLOCATION_STATUS_VALUES = {
  BOTH: 1,
  NONE: 2,
  SYSTEM: 3,
  CUSTOME: 4,
};
export const COLLOCATION_STATUS_TEXTS = {
  BOTH: '托管中',
  NONE: '未托管',
  SYSTEM: '一键托管中',
  CUSTOME: '自定义托管中',
};
